export interface Character {
  id: string;
  name: string;
  actor: string;
  role: string;
  desc: string;
  image: string;
}

export const characters: Character[] = [
  {
    id: "xiangxi",
    name: "向西",
    actor: "张建声 饰",
    role: "男主角 · 故事主视角",
    desc: "全片的叙事者与情绪核心。从一个对两性关系一知半解的香港少年，到远赴英伦、经历分手，再到踏上北上的旅途，他的每一次转变都是故事的推进力。他并不始终讨喜，但足够真实，观众跟着他一起困惑、一起长大。",
    image:
      "https://readdy.ai/api/search-image?query=A%20lone%20young%20Hong%20Kong%20man%20standing%20with%20his%20back%20to%20camera%20on%20a%20neon%20lit%20street%20at%20night%2C%20moody%20cinematic%20lighting%20in%20deep%20red%20and%20amber%20tones%2C%20soft%20bokeh%20city%20lights%2C%20stylized%20film%20poster%20aesthetic%2C%20quiet%20melancholic%20mood&width=800&height=1000&seq=cast-xiangxi-01&orientation=portrait",
  },
  {
    id: "wangjing",
    name: "王静",
    actor: "王宗尧 饰",
    role: "学长 · 价值观引导者",
    desc: "向西在校园时期结识的学长，也是带他认识“另一套世界观”的关键人物。他见多识广、言行洒脱，用一种近乎调侃的方式给向西灌输成年人世界的规则，既是引路人，也像一面镜子，映出向西的犹豫与天真。",
    image:
      "https://readdy.ai/api/search-image?query=A%20confident%20young%20Cantonese%20man%20leaning%20against%20a%20concrete%20wall%20under%20warm%20street%20lamps%2C%20cinematic%20portrait%2C%20deep%20crimson%20and%20gold%20color%20grade%2C%20shallow%20depth%20of%20field%2C%20stylized%20moody%20film%20aesthetic%20with%20soft%20grain&width=800&height=1000&seq=cast-wangjing-02&orientation=portrait",
  },
  {
    id: "james",
    name: "占士",
    actor: "胡耀辉 饰",
    role: "好友 · 同行伙伴",
    desc: "性格外放、行动力强的伙伴，也是导演本人在片中出演的角色。他总能把沉重的话题说得好笑，把犹豫的人推上路。旅途中许多荒诞又生动的段落，都由他的出现被点燃。",
    image:
      "https://readdy.ai/api/search-image?query=A%20cheerful%20Cantonese%20man%20laughing%20in%20a%20dim%20night%20market%20alley%2C%20warm%20amber%20and%20red%20lighting%2C%20cinematic%20portrait%2C%20bokeh%20lantern%20lights%20behind%2C%20stylized%20retro%20Hong%20Kong%20cinema%20look%20with%20soft%20grain&width=800&height=1000&seq=cast-james-03&orientation=portrait",
  },
  {
    id: "zoe",
    name: "Zoe",
    actor: "郭颖儿 饰",
    role: "关键情感线角色",
    desc: "与向西生命中的一段重要关系相关。她的出现让向西第一次把感情与现实放在一起衡量，也让他明白，对方并不是为了填补谁的空白而存在。两人之间那些没能说出口的话，是全片情绪最柔软的部分。",
    image:
      "https://readdy.ai/api/search-image?query=A%20thoughtful%20young%20woman%20looking%20out%20of%20a%20rain%20speckled%20window%20at%20night%2C%20gentle%20warm%20indoor%20lighting%2C%20cinematic%20portrait%2C%20crimson%20and%20gold%20accent%20tones%2C%20stylized%20romantic%20mood%20with%20soft%20focus&width=800&height=1000&seq=cast-zoe-04&orientation=portrait",
  },
  {
    id: "xiaosi",
    name: "小思",
    actor: "王李丹妮 饰",
    role: "旅途中的重要相遇",
    desc: "在向西旅途的不同阶段出现，带来戏剧性的对照。她的存在让故事在热闹的见闻之外多了一层现实感——每个人背后都有自己的处境，而不是别人想象里的标签。",
    image:
      "https://readdy.ai/api/search-image?query=A%20poised%20young%20woman%20in%20an%20elegant%20evening%20dress%20standing%20in%20a%20dim%20hotel%20lobby%2C%20warm%20low%20key%20lighting%20in%20amber%20and%20crimson%2C%20cinematic%20portrait%2C%20moody%20stylized%20film%20aesthetic%20with%20soft%20grain%20and%20bokeh&width=800&height=1000&seq=cast-xiaosi-05&orientation=portrait",
  },
  {
    id: "mona",
    name: "Mona",
    actor: "何佩瑜 饰",
    role: "旅途中的人物",
    desc: "人物群像中的一员，代表了旅途中不期而遇的一类面孔。她与向西的互动轻松而短暂，却在细枝末节处流露出都市人际关系的疏离，为整段旅程补充了不同侧面的观察。",
    image:
      "https://readdy.ai/api/search-image?query=A%20stylish%20young%20woman%20in%20a%20city%20bar%20at%20late%20night%2C%20warm%20amber%20and%20deep%20red%20ambient%20lighting%2C%20cinematic%20portrait%2C%20bokeh%20glassware%20and%20lights%2C%20stylized%20moody%20film%20aesthetic%20with%20soft%20grain&width=800&height=1000&seq=cast-mona-06&orientation=portrait",
  },
];